import { type FormEvent, useState } from 'react';
import { requestPasswordReset } from '../api/client';
import { Field, Input } from '../components/form';
import { Alert, Button, Card } from '../components/ui';
import { ThemeSwitcher } from '../theme/ThemeSwitcher';
import styles from './screens.module.css';

/** Tela "Esqueci minha senha": pede o e-mail e dispara o link de recuperação. */
export function EsqueciSenha({ onBack }: { onBack: () => void }) {
  const [email, setEmail] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [enviando, setEnviando] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!email.trim()) return;
    setEnviando(true);
    // Resposta sempre neutra (anti-enumeração): a UI confirma o envio de qualquer forma.
    await requestPasswordReset(email.trim().toLowerCase());
    setEnviando(false);
    setEnviado(true);
  }

  return (
    <div className={styles.centerScreen}>
      <Card className={styles.authCard}>
        <div className={styles.authHead}>
          <span className={styles.brand}>eCondomínio</span>
          <ThemeSwitcher compact />
        </div>
        <h1>Recuperar senha</h1>
        {enviado ? (
          <>
            <Alert kind="success">
              Se houver uma conta com esse e-mail, enviamos um link para redefinir a senha. O link
              expira em 1 hora.
            </Alert>
            <div style={{ marginTop: 'var(--space-4)' }}>
              <Button block variant="secondary" onClick={onBack}>
                Voltar para o login
              </Button>
            </div>
          </>
        ) : (
          <>
            <p className="muted">
              Informe seu e-mail e enviaremos um link para criar uma nova senha.
            </p>
            <form onSubmit={onSubmit} noValidate>
              <Field label="E-mail">
                {(id) => (
                  <Input
                    id={id}
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                )}
              </Field>
              <div style={{ marginTop: 'var(--space-4)' }}>
                <Button type="submit" block disabled={enviando}>
                  {enviando ? 'Enviando…' : 'Enviar link'}
                </Button>
              </div>
            </form>
            <div style={{ marginTop: 'var(--space-3)' }}>
              <Button block variant="ghost" onClick={onBack}>
                Voltar
              </Button>
            </div>
          </>
        )}
      </Card>
    </div>
  );
}
